var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.569,
    height: 18.6,
    viewBox: "0 0 18.569 18.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-946.687 -1508.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M962.318,1508.916a.663.663,0,0,1,.426.716c-.01.769,0,1.538,0,2.307,0,.474-.2.677-.671.677-.8,0-1.6,0-2.393,0-.4,0-.662-.247-.614-.592a.815.815,0,0,1,.2-.389c.19-.218.406-.413.653-.659-.515-.205-.984-.435-1.476-.582a7.954,7.954,0,0,0-7.308,1.215,7.858,7.858,0,0,0-3.282,5.592,8.188,8.188,0,0,0,16.225,2.215c.055-.37.068-.747.087-1.121a.577.577,0,0,1,.433-.61.551.551,0,0,1,.631.365c0,.009.018.014.027.021v.69c-.011.064-.025.128-.033.192-.044.335-.07.674-.133,1.006a9.291,9.291,0,0,1-7.516,7.413c-.35.06-.7.1-1.056.143H955.43c-.053-.01-.105-.022-.158-.031-.588-.1-1.189-.153-1.762-.308a9.3,9.3,0,0,1-6.655-10.7,9.146,9.146,0,0,1,2.518-4.792,9.05,9.05,0,0,1,5-2.624c.35-.061.7-.1,1.056-.143h1.088c.251.031.5.059.753.094a9.085,9.085,0,0,1,3.3,1.132.148.148,0,0,0,.215-.035c.277-.287.557-.572.846-.847.133-.127.288-.23.434-.344Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1140.287,1628.214h.211c.9,0,1.8,0,2.7,0a.546.546,0,1,1-.012,1.088c-.967,0-1.933,0-2.9,0-.181,0-.363,0-.544,0a.534.534,0,0,1-.541-.543q-.008-1.752,0-3.5a.542.542,0,1,1,1.083.023c0,.908,0,1.816,0,2.724Z",
    transform: "translate(-183.77 -110.543)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.2bf7cd484c0ae5c85a5d2eb28cd87b53.svg";
export { ForwardRef as ReactComponent };